import { ApiPrice } from '@ibe/api';

class PriceFactory {
  static create(final = 0, currency: string): ApiPrice {
    return {
      basePrice: 0,
      currencyCode: currency,
      finalPrice: final,
      isInclusive: false,
      isStartingAt: false,
      modifiers: []
    };
  }

  static fromPrices(prices: ApiPrice[]): ApiPrice {
    const currencyCode = prices
      .map(value => value.currencyCode)
      .find(value => value != null) as string;

    const price = this.create(0, currencyCode);

    prices.forEach(item => {
      price.basePrice += item.basePrice;
      price.finalPrice += item.finalPrice;

      price.modifiers = price.modifiers.concat(item.modifiers);
    });

    return price;
  }
}

export default PriceFactory;
